import { GrowthBook } from '@growthbook/growthbook-react'

export const growthbook = new GrowthBook({
    apiHost: 'https://cdn.growthbook.io',
    clientKey: 'sdk-AcOJiPy1IXjqHKGa',
    enableDevMode: window.location.hostname === 'localhost',
})
